(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!window.syncProductCardTitleOverflow) {
    window.syncProductCardTitleOverflow = function syncProductCardTitleOverflow(root = document) {
      const titles = root.querySelectorAll('[data-product-card-title]');

      titles.forEach((title) => {
        const firstTitleText = title.querySelector('.product-card__title-text');

        if (!firstTitleText) return;

        title.classList.remove('product-card__title--overflowing');

        if (firstTitleText.scrollWidth > title.clientWidth) {
          title.classList.add('product-card__title--overflowing');
        }
      });
    };

    window.syncProductCardTitleOverflow();
    window.addEventListener('resize', () => window.syncProductCardTitleOverflow());
    document.addEventListener('shopify:section:load', (event) => window.syncProductCardTitleOverflow(event.target));
  } else {
    window.syncProductCardTitleOverflow();
  }

  if (!window.productCardQuickAddDelegateBound) {
    window.productCardQuickAddDelegateBound = true;

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-quick-add-modal-close]');

      if (closeButton) {
        const modal = closeButton.closest('quick-add-modal');

        if (modal) modal.hide();
        return;
      }

      const trigger = event.target.closest('[data-quick-add-modal-trigger]');

      if (!trigger) return;

      const modal = document.getElementById(trigger.dataset.quickAddModalId);

      if (modal) modal.show(trigger);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
